import { COLLECTION_MECHANIC } from '@/models/collection-mechanic/collection-mechanic.types';

export const getFirstKeyFromCollectionMechanic = (
  object: Record<string, any>,
) => {
  const enumValues = Object.values(COLLECTION_MECHANIC);
  const foundKey = Object.keys(object).find(key =>
    enumValues.includes(key as COLLECTION_MECHANIC),
  );
  return foundKey ? object[foundKey] : null;
};
